export const HEAT_COMPANIES_LAYER = 'companies-intensity';
export const HEAT_POINTS_LAYER = 'company-point';
export const HEAT_SOURCE_NAME = 'heatmap';
export const POINTERS_CLASS_NAME = 'crono-map-pointer';
export const CIRCLE_LAYER_AND_SOURCE = 'circle-polygon';
export const SATELLITE_LAYER_AND_SOURCE = 'crono-satellite';
export const SAVE_POLYGON_POPUP_CLASS_NAME = 'save-poligon-pop-map';
export const SAVE_POLYGON_POPUP_ICON_CLASS_NAME = 'save-poligon-pop-map-icon';
export const POLYGON_LAYER_ID = 'drawPolygonSource';
export const CRONO_GOOGLE_API_LOADER = 'crono-google-api-loader';
